module.exports = __webpack_public_path__ + "static/media/H.78a0a777.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/H.jpg
// module id = 76
// module chunks = 0